import {
    faCode,
    faChartLine,
    faEllipsis,
    faUserTie,
    faUser,
} from "@fortawesome/free-solid-svg-icons";
import werknemerImage from "./images/kandidaten.jpg";
import werkgeverImage from "./images/werkgever.jpg";
import {VoorWerknemers} from "./components/VoorWerknemers";
import {VoorWerkgevers} from "./components/VoorWerkgevers";

export const reCAPTCHAKey = "6Lcj6kUaAAAAAJfhzrZdbSkeN-9d-4X4Md0VM01c";
export const baseUrl =
    "https://rp-one-contact-service-2tky8.ondigitalocean.app/api";

export const companyValues = [
    {
        title: "Kwaliteit boven kwantiteit",
        text: "Het leveren van de ideale versterking voor uw project is ons doel. Consultants en partners worden begeleid gedurende het gehele project en zelfs daarna.",
    },
    {
        title: "Langetermijnvisie",
        text: "Wij beschouwen onze consultants en partners als familie. Na onze interventie stopt het werk niet, integendeel.",
    },
    {
        title: "Opleiding",
        text: "Al onze consultants worden voorzien van een continue, professionele opleiding zodat zij hun job naar behoren kunnen uitoefenen. Ook onze niet-technische collega’s worden regelmatig bijgeschoold.",
    },
    {
        title: "Respect en integriteit",
        text: "Wij hechten enorm veel belang aan het respecteren van de wensen van al onze stakeholders. Alles gebeurt op een discrete manier met oog voor de geldende privacyregels.",
    },
];

export const jobs = [
    {
        title: "Software",
        icon: faCode,
        id: "software",
        openings: [
            {
                title: ".Net Developer",
                place: "Vlaanderen - Brussel",
                id: "net-developer",
                jobDescription: [
                    "Jouw rol zal zijn om deel te nemen aan onze bestaande projectteams, deze te ondersteunen of te leiden en hen te helpen om het project om te zetten in een technisch succes door het gewenste eindresultaat voor de klant te produceren.",
                    "Op basis van je Career Development Path, je wensen, je interesses en je expertiseniveau, kun je deelnemen aan een project van A tot Z, dat wil zeggen vanaf het Blueprint / Audit niveau tot de implementatie van de voorgestelde oplossing.",
                ],
                jobRequirements: [
                    "U bent afgestudeerd als Bachelor of Master in IT of een aanverwante richting.",
                    "U hebt een passie voor programmeren binnen het .NET framework. Je wilt je kennis uitbreiden van C#, .NET Core, Azure en andere .NET gerelateerde frameworks zoals Entity Framework, Xamarin.Forms etc.",
                    "Hou je van afwisseling en wil je ervaring opdoen in verschillende projecten binnen toonaangevende, innovatieve bedrijven.",
                    "Als gezicht van RP One bij de klant help je mee om de relatie met de klant te versterken.",
                    "Je bent gepassioneerd door technologie en volgt de laatste trends.",
                    "Clean coding en andere best practices van professioneel software vakmanschap maken deel uit van je dagelijkse job routine en je zoekt naar duo's en mentors die er net zo over denken en die hun ervaring met jou delen.",
                    "Je spreekt Nederlands en/of Frans en je kunt je vloeiend uitdrukken in het Engels.",
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede work-life balance met thuiswerk mogelijkheden.",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen, zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten.",
                ],
            },
            {
                title: ".Net Software Engineer",
                place: "Vlaanderen (Hybrid)",
                id: "net-software-engineer",
                jobDescription: [
                    "Jouw rol zal zijn om deel te nemen aan onze bestaande projectteams, deze te ondersteunen of te leiden en hen te helpen om het project om te zetten in een technisch succes door het gewenste eindresultaat voor de klant te produceren.",
                    "Op basis van je Career Development Path, je wensen, je interesses en je expertiseniveau, kun je deelnemen aan een project van A tot Z, dat wil zeggen vanaf het Blueprint / Audit niveau tot de implementatie van de voorgestelde oplossing.",
                ],
                jobRequirements: [
                    "Je bent afgestudeerd als Bachelor of Master in IT of een aanverwante richting met minimaal 5 jaar ervaring in een .NET gerichte omgeving.",
                    "Je hebt een passie voor het bouwen van applicaties, web applicaties.",
                    "Je bent vertrouwd met concepten zoals DevOps, AWS of Azure Cloud oplossingen en je kan in aan Agile omgeving draaien.",
                    "Als gezicht van RP One naar de klant toe, help je de relatie met de klant te versterken.",
                    "Je spreekt vloeiend Nederlands.",
                    "Je bent in het bezit van een rijbewijs B."
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een kans je te bewijzen in een toekomstgericht knelpuntberoep en hierin professionele expertise op te bouwen.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede balans tussen werk en privéleven met thuiswerk mogelijkheden.",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen, zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten.",
                ],
            },
            {
                title: "Java Developer",
                place: "Vlaanderen - Brussel",
                id: "java-developer",
                jobDescription: [
                    "Jouw rol zal zijn om deel te nemen aan onze bestaande projectteams, deze te ondersteunen of te leiden en hen te helpen om het project om te zetten in een technisch succes door het gewenste eindresultaat voor de klant te produceren.",
                    "Op basis van je Career Development Path, je wensen, je interesses en je expertiseniveau, kun je deelnemen aan een project van A tot Z, dat wil zeggen vanaf het Blueprint / Audit niveau tot de implementatie van de voorgestelde oplossing.",
                ],
                jobRequirements: [
                    "Je hebt praktische ervaring met een aantal van onderstaande Java-technologieën",
                    "U bent afgestudeerd als Bachelor of Master in IT of een aanverwante richting.",
                    "Je hebt een passie voor ontwikkelen in Java en je hebt zin om je te verdiepen in Spring (Boot) frameworks en aanverwante Java tools?",
                    "Je houdt van afwisseling en wil graag ervaring opdoen in verschillende projecten binnen toonaangevende, innovatieve bedrijven.",
                    "Als gezicht van RP One bij de klant help je mee om de relatie met de klant te versterken.",
                    "Je bent gepassioneerd door technologie en volgt de laatste trends.",
                    "Clean coding en andere best practices van professioneel software vakmanschap maken deel uit van je dagelijkse job routine en je zoekt duo's en mentors die er net zo over denken en die hun ervaring met jou delen.",
                    "Je spreekt Nederlands en/of Frans en je kan je vlot uitdrukken in het Engels.",
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede work-life balance met thuiswerk mogelijkheden.",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen, zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten.",
                ],
            },
            {
                title: "Java Software Engineer",
                place: "Vlaanderen (Hybrid)",
                id: "java-software-engineer",
                jobDescription: [
                    "Jouw rol zal zijn om deel te nemen aan onze bestaande projectteams, deze te ondersteunen of te leiden en hen te helpen om het project om te zetten in een technisch succes door het gewenste eindresultaat voor de klant te produceren.",
                    "Op basis van je Career Development Path, je wensen, je interesses en je expertiseniveau, kun je deelnemen aan een project van A tot Z, dat wil zeggen vanaf het Blueprint / Audit niveau tot de implementatie van de voorgestelde oplossing.",
                ],
                jobRequirements: [
                    "Je bent afgestudeerd als Bachelor of Master in IT of een aanverwante richting met minimaal 5 jaar ervaring in een Java gerichte omgeving.",
                    "Je hebt een passie voor het bouwen van applicaties, web applicaties.",
                    "Je bent vertrouwd met concepten zoals DevOps, AWS of Azure Cloud oplossingen en je kan in aan Agile omgeving draaien.",
                    "Als gezicht van RP One naar de klant toe, help je de relatie met de klant te versterken.",
                    "Je spreekt vloeiend Nederlands.",
                    "Je bent in het bezit van een rijbewijs B."
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een kans je te bewijzen in een toekomstgericht knelpuntberoep en hierin professionele expertise op te bouwen.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede balans tussen werk en privéleven met thuiswerk mogelijkheden.",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen, zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten.",
                ],
            },
            {
                title: "Junior Software Engineer Python",
                place: "Vlaanderen (Hybrid)",
                id: "python-dev",
                jobDescription: [
                    "Jouw rol zal zijn om deel te nemen aan, te ondersteunen of te leiden van onze bestaande projectteams en hen te helpen om het project om te zetten in een technisch succes door het produceren van het gewenste eindresultaat voor de klant.",
                    "Op basis van je carrièrepad, je wensen, je interesses en je expertiseniveau, kun je deelnemen aan een project van A tot Z, dat wil zeggen vanaf het Blueprint / Audit niveau tot en met de implementatie van de voorgestelde oplossing.",
                ],
                jobRequirements: [
                    "Je bent afgestudeerd als Master or burgerlijk ingenieur in IT of een aanverwante richting.",
                    "Je hebt een passie voor ontwikkelen in Python en je hebt zin om je te verdiepen in PyTorch, Django, Keras or other frameworks en gerelateerde Python tools and libraries (Scikit-learn, NumPy, Tensor Flow, etc.?",
                    "Je houdt van afwisseling en wil graag ervaring opdoen in verschillende projecten binnen toonaangevende, innovatieve bedrijven.",
                    "Als gezicht van RP One bij de klant help je mee om de relatie met de klant te versterken.",
                    "Je bent gepassioneerd door technologie en volgt de laatste trends op de voet.",
                    "Clean coding en overige best practices van professioneel software vakmanschap maken deel uit van je dagelijkse job routine en je zoekt naar mentors die er net hetzelfde over denken en die hun ervaring met jou delen.",
                    "Je spreekt Nederlands en je kunt je vloeiend uitdrukken in het Engels."
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een kans je te bewijzen in een toekomstgericht knelpuntberoep en hierin professionele expertise op te bouwen.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede balans tussen werk en privéleven met thuiswerkmogelijkheden",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten."
                ],
            },
        ],
    },
    {
        title: "Data & AI",
        icon: faChartLine,
        id: "data-ai",
        openings: [
            {
                title: "Power BI Developer",
                place: "Vlaanderen (Hybrid)",
                id: "BI-dev",
                jobDescription: [
                    "Ontwerpen en ontwikkelen van interactieve Power BI-rapporten en dashboards.",
                    "Analyseren van complexe datasets en het identificeren van trends en inzichten.",
                    "Samenwerken met business stakeholders om hun databehoeften te begrijpen en te vertalen naar oplossingen.",
                    "Optimaliseren van bestaande rapportages en processen.",
                    "Uitvoeren van data-integratie en -transformatie met behulp van Power Query en DAX.",
                    "Documenteren van technische specificaties en rapportagestructuren."
                ],
                jobRequirements: [
                    "Minimaal 2 jaar ervaring als Power BI Developer of in een vergelijkbare rol.",
                    "Sterke kennis van Power BI, DAX en Power Query.",
                    "Ervaring met data modellering en ETL-processen.",
                    "Kennis van SQL en ervaring met databases (bijvoorbeeld SQL Server, Azure).",
                    "Analytisch denkvermogen en probleemoplossend vermogen.",
                    "Uitstekende communicatieve vaardigheden in Nederlands en Engels."
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede work-life balance met thuiswerk mogelijkheden.",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen, zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten.",
                ],
            },
            {
                title: "Data Scientist",
                place: "Vlaanderen (Hybrid)",
                id: "data-scientist",
                jobDescription: [
                    "Jouw rol is het analyseren en interpreteren van complexe datasets met behulp van AI en machine learning technieken, en deze om te zetten in technische oplossingen om op die manier het gewenste eindresultaat voor de klant te produceren.",
                    "Je analyseert grote datasets om trends, patronen en inzichten te ontdekken.",
                    "Je ontwikkelt en implementeert machine learning modellen om voorspellingen te doen of beslissingen te automatiseren.",
                    "Je neemt ook deel in de ontwikkeling van nieuwe machine learning modellen en prototypes en evalueert deze met de data analisten.",
                    "Je communiceert bevindingen en aanbevelingen aan belanghebbenden, vaak door middel van visualisaties en presentaties."
                ],
                jobRequirements: [
                    "Je bent afgestudeerd als Master in IT, Computerwetenschappen of Informatica. Je hebt kennis van R, Python (TensorFlow, PyTorch, Scikit-learn, Pandas, NumPy), Exploratory Data Analysis.",
                    "Je hebt minimaal 3 jaar ervaring als Data Scientist",
                    "Je hebt een affiniteit voor verschillende machine learning-algoritmen, zoals regressie, classificatie, clustering en deep learning.",
                    "Een eerste ervaring met Matplotlib, Seaborn, of Tableau en met big data technologieën (Hadoop, Spark of NoSQL databases) is een plus.",
                    "Je bent vertrouwd met databases en query-talen zoals SQL om gegevens efficiënt te kunnen opslaan en ophalen.",
                    "Je bent gepassioneerd door technologie en volgt de laatste trends op de voet (augmented analytics, data fabric, NLU/NLP, etc).",
                    "Je spreekt vloeiend Nederlands.",
                    "Je bent in het bezit van een rijbewijs B."
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een kans je te bewijzen in een toekomstgericht knelpuntberoep en hierin professionele expertise op te bouwen.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede balans tussen werk en privéleven met thuiswerkmogelijkheden",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten."
                ],
            },
            {
                title: "Junior AI Data Scientist",
                place: "Vlaanderen (Hybrid)",
                id: "junior-AI-data-scientist",
                jobDescription: [
                    "Jouw rol is het analyseren en interpreteren van complexe datasets met behulp van AI en machine learning technieken, en deze om te zetten in technische oplossingen om op die manier het gewenste eindresultaat voor de klant te produceren.",
                    "Je analyseert grote datasets om trends, patronen en inzichten te ontdekken.",
                    "Je ontwikkelt en implementeert machine learning modellen om voorspellingen te doen of beslissingen te automatiseren.",
                    "Je neemt ook deel in de ontwikkeling van nieuwe machine learning modellen en prototypes en evalueert deze met de data analisten.",
                    "Je communiceert bevindingen en aanbevelingen aan belanghebbenden, vaak door middel van visualisaties en presentaties."
                ],
                jobRequirements: [
                    "Je bent afgestudeerd als Master in IT of Science (wiskunde, fysica, etc.); burgerlijk of industrieel ingenieur.",
                    "Je hebt kennis van R, Python (TensorFlow, PyTorch, Scikit-learn, Pandas, NumPy), Exploratory Data Analysis.",
                    "Je hebt een affiniteit voor verschillende machine learning-algoritmen, zoals regressie, classificatie, clustering en deep learning.",
                    "Een eerste ervaring met Matplotlib, Seaborn, of Tableau en met big data technologieën (Hadoop, Spark of NoSQL databases) is een plus.",
                    "Je bent vertrouwd met databases en query-talen zoals SQL om gegevens efficiënt te kunnen opslaan en ophalen.",
                    "Je bent gepassioneerd door technologie en volgt de laatste trends op de voet (augmented analytics, data fabric, NLU/NLP, etc).",
                    "Je spreekt Nederlands en je kunt je vloeiend uitdrukken in het Engels."
                ],
                jobBenefits: [
                    "Een inspirerende werkomgeving met leuke collega's met een sterke focus op sfeer en teamspirit.",
                    "Een kans je te bewijzen in een toekomstgericht knelpuntberoep en hierin professionele expertise op te bouwen.",
                    "Een persoonlijk carrièreplan en transparant opleidingsprogramma dat regelmatig besproken wordt met onze talent manager en dat je voorbereidt op de uitdaging van een sleutelpositie binnen onze klantenorganisatie.",
                    "Een goede balans tussen werk en privéleven met thuiswerkmogelijkheden",
                    "Een full-option loonpakket, inclusief tal van extralegale voordelen zoals verzekeringen, netto vergoedingen, extra vakantiedagen, enz.",
                    "Een premium bedrijfswagenpark in slimme combinatie met andere duurzame faciliteiten."
                ],
            },
        ],
    },
    {
        title: "Other",
        icon: faEllipsis,
        id: "other",
        openings: [
            {
                title: "Recruitment Officer",
                place: "Vilvoorde",
                id: "recruitment-officer",
                jobDescription: [
                    "Understand the business recruitment needs.",
                    "Identify and use the relevant channel for finding the right candidates.",
                    "Extend your network in your technology domain of recruitment, candidate hunting and improve the companies visibility.",
                    "Pre-Selection screening and candidate presentation.",
                    "Participate to projects (employer branding, student fairs, recruitment campaigns).",
                    "Ownership of the companies Social Media and Marketing strategy.",
                ],
                jobRequirements: [
                    "First of all, the aspect of interviewing, listening to peoples stories and detecting their ambitions is not a duty but rather your second nature.",
                    "Furthermore, you are graduated as a Bachelor or Master in the fields of business, marketing, communication.",
                    "You have a strong affinity or first experience in professional use of Social Media.",
                    "You are a strong communicator and you think out of the box.",
                    "You have organizational skills and stress resistance to ensure that you achieve concrete results in an efficient manner.",
                    "You work autonomously and know how to motivate others to go for a goal together.",
                    "You are fluent in Dutch, French with a strong command of English.",
                    "You have a driving license B.",
                ],
                jobBenefits: [
                    "A fascinating position where you can work in a very independent and organized manner.",
                    "Dynamic and fast-growing organization that offers development and career opportunities to young, driven people with entrepreneurial mindset according to your personal interest and affinities.",
                    "Competitive salary package, supplemented with a premium company car and fringe benefits including an attractive commission system.",
                ],
            },
            {
                title: "Spontane Sollicitatie",
                place: "Belgium",
                id: "spontane-sollicitatie",
                jobDescription: [
                    "Niets dat je op het lijf geschreven is, maar wel interesse in wat we doen? Solliciteer dan spontaan want bij RP One geloven we in bouwen aan je eigen pad!",
                    "Bezorg ons je meest recente cv en één van onze recruiters neemt contact met u op om uw verwachtingen te begrijpen en u te helpen bij uw zoektocht naar een nieuwe baan.",
                ],
            },
        ],
    },
];

export const solicitationProcedure = [
    {
        title: "screening",
        text: "We doen een screening van je CV. Hierna bellen je op om te luisteren hoe we jou gaan kunnen helpen in je loopbaan. Zien we een match dan nodigen we je graag uit voor een eerste gesprek.",
        id: 1,
    },
    {
        title: "interview partner",
        text: "We bespreken dit met onze partner(s). Zien zij ook een match dan bereiden we jou voor op je eerste interview met onze partner. Is dit interview positief dan kan er een bijkomend interview gepland worden naargelang de wensen van onze partner.",
        id: 2,
    },
    {
        title: "Nieuwe baan!",
        text: "Is je finale interview positief, kloppen je referenties en is er een deal over de voorwaarden dan wensen we jou proficiat met je nieuwe baan!",
        id: 3,
    },
];

export const hoeWijWerken = [
    {
        title: "Voor werknemers",
        icon: faUser,
        id: 1,
        image: werknemerImage,
        content: <VoorWerknemers/>,
    },
    {
        title: "Voor werkgevers",
        icon: faUserTie,
        id: 2,
        image: werkgeverImage,
        content: <VoorWerkgevers/>,
    },
];
